import { call, getContext, put, takeEvery } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* resetBasket() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield call(BasketAPI.resetBasketForShopLanding, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createGetBasicAction());
        yield put(basketActions.createGetAction());
    }
    catch (_a) { }
}
export function* resetBasketSaga() {
    yield takeEvery(BasketActionTypes.RESET_BASKET_FOR_SHOPLANDING, resetBasket);
}
